import React, { useEffect, useState } from "react";
import Avatar from "@material-ui/core/Avatar";

const failedProfilePictureUrls = new Set();

const normalizeUrl = value => String(value || "").trim();

const ContactAvatar = ({
  contact,
  src,
  imgProps = {},
  children,
  ...avatarProps
}) => {
  const profilePicUrl = normalizeUrl(src || contact?.profilePicUrl);
  const [failed, setFailed] = useState(
    !profilePicUrl || failedProfilePictureUrls.has(profilePicUrl)
  );

  useEffect(() => {
    setFailed(!profilePicUrl || failedProfilePictureUrls.has(profilePicUrl));
  }, [profilePicUrl]);

  const handleError = event => {
    if (profilePicUrl) {
      failedProfilePictureUrls.add(profilePicUrl);
    }
    setFailed(true);

    if (typeof imgProps.onError === "function") {
      imgProps.onError(event);
    }
  };

  return (
    <Avatar
      {...avatarProps}
      src={failed ? undefined : profilePicUrl}
      imgProps={{
        ...imgProps,
        loading: imgProps.loading || "lazy",
        onError: handleError
      }}
    >
      {children}
    </Avatar>
  );
};

export default ContactAvatar;
